import { createSlice } from "@reduxjs/toolkit";
import { ownedUserIds, belongsToSomeoneElse, isStaffProfile } from "../ownership";
export const LOGOUT = 'LOGOUT';

const initialState = {
    isAuthorised: false,
    authorisedUser: null,
    resetPasswordStatus: {
        isOpen: false,
        type: "",
        message: ""
    },
    employeeTransactionData: null,
    i9VerificationType: null,
    partialI9SelectedCard: null,
    isI9FormCompleted: false,
    isBasicFormEditing: false,
    isI9ProcessManual: false,
};

const AppSlice = createSlice({
    name: "App",
    initialState,
    reducers: {
        setIsAuthorised: (state, actions) => {
            state.isAuthorised = actions.payload;
        },
        setAuthorisedUser: (state, actions) => {
            const owned = ownedUserIds(actions.payload);
            const staff = isStaffProfile(actions.payload);
            const storedUserId =
                state.employeeTransactionData?.userId ??
                state.employeeTransactionData?.user_Id;
            if (!staff && belongsToSomeoneElse(owned, storedUserId)) {
                state.employeeTransactionData = null;
                state.partialI9SelectedCard = null;
                state.i9VerificationType = null;
                state.isI9FormCompleted = false;
                state.isBasicFormEditing = false;
                state.isI9ProcessManual = false;
            }
            state.authorisedUser = actions.payload;
        },
        setResetPasswordStatus: (state, actions) => {
            state.resetPasswordStatus = actions.payload;
        },
        setEmployeeTransactionData: (state, actions) => {
            state.employeeTransactionData = actions.payload;
        },
        setI9VerificationType: (state, actions) => {
            state.i9VerificationType = actions.payload;
        },
        setPartialI9SelectedCard: (state, actions) => {
            state.partialI9SelectedCard = actions.payload;
        },
        setIsI9FormCompleted: (state, actions) => {
          state.isI9FormCompleted = actions.payload;
        },
        setIsBasicFormEditing: (state, actions) => {
            state.isBasicFormEditing = actions.payload;
        },
        setIsI9ProcessManual: (state, actions) => {
          state.isI9ProcessManual = actions.payload;
        },
    }
});

export const logout = () => ({
    type: LOGOUT,
});

export const {
    setIsAuthorised,
    setAuthorisedUser,
    setResetPasswordStatus,
    setEmployeeTransactionData,
    setI9VerificationType,
    setPartialI9SelectedCard,
  setIsI9FormCompleted,
  setIsBasicFormEditing,
  setIsI9ProcessManual,
} = AppSlice.actions;

export default AppSlice.reducer;